export const customerKeyword = (state) => {
  return state.customerKeyword;
};
export const isCheckToken = (state) => {
  return state.isCheckToken;
};
export const apiHost = (state) => {
  return state.apiHost;
};
export const leftMenuNav = (state) => {
  return state.leftMenuNav;
};
export const userInfo = (state) => {
  return state.userInfo;
};

export const send_userinfo = (state) => {
  return state.send_userinfo;
};

export const name = (state) => {
  return state.name;
};

export const age = (state) => {
  return state.age;
};

export const other = (state) => {
  return `My name is ${state.name}, I am ${state.age}.`;
};

export const personl = (state) => {
  return state.personl;
};

export const activeIndex = (state) => {
  return state.activeIndex;
};

export const changData = (state) => {
  return state.changData;
};
export const query_search = (state) => {
  return state.query_search;
};

/*改变试题状态*/
export const questionChange = (state) => {
  return state.questionChange;
};

/*删除试题*/
export const delQuestion = (state) => {
  return state.delQuestion;
};

/*是否商学院主题*/
export const isItcScene = (state) => {
  return state.isItcScene;
};
